import {
	getIsPlanInfoReady,
	isConfluenceMacro,
	isExportMode,
} from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/app';
import { getCustomFields } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/custom-fields';
import { getIssuePrioritiesIdList } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/issue-priorities';
import {
	getDateConfiguration,
	getPlanningUnit,
} from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/plan';
import { getViewMode } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/view-settings';
import { getNamespaceFromActiveView } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/views';
import { getVisualisationSorting } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/visualisations';
import { getMatchingConfiguredDate } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/view/main/tabs/roadmap/fields/utils';
import { createSelector } from '@atlassian/jira-portfolio-3-portfolio/src/common/reselect';
import { getColumns } from '../query';

const queryPure = (
	columns: ReturnType<typeof getColumns>,
	sorting: ReturnType<typeof getVisualisationSorting>,
	customFields: ReturnType<typeof getCustomFields>,
	dateConfiguration: ReturnType<typeof getDateConfiguration>,
	planningUnit: ReturnType<typeof getPlanningUnit>,
	issuePrioritiesIdList: ReturnType<typeof getIssuePrioritiesIdList>,
	isPlanInfoReady: ReturnType<typeof getIsPlanInfoReady>,
	viewNamespace: ReturnType<typeof getNamespaceFromActiveView>,
	exportMode: boolean,
	viewMode: ReturnType<typeof getViewMode>,
	// eslint-disable-next-line @typescript-eslint/no-shadow
	isConfluenceMacro: boolean,
) => ({
	columns,
	sorting,
	customFields,
	getMatchingConfiguredDate: getMatchingConfiguredDate(dateConfiguration),
	planningUnit,
	issuePrioritiesIdList,
	areCustomFieldsReady: isPlanInfoReady,
	viewNamespace,
	isExportMode: exportMode,
	viewMode,
	isConfluenceMacro,
});

export const query = createSelector(
	[
		getColumns,
		getVisualisationSorting,
		getCustomFields,
		getDateConfiguration,
		getPlanningUnit,
		getIssuePrioritiesIdList,
		getIsPlanInfoReady,
		getNamespaceFromActiveView,
		isExportMode,
		getViewMode,
		isConfluenceMacro,
	],
	queryPure,
);

export default query;
